import React, { useState } from 'react';
import { Button, Form, Input, Checkbox, notification } from 'antd';
import { login } from '../../api/user';
import Cookie from 'js-cookie';
import { ACCESS_TOKEN_KEY, APP_ID, USER_ID_KEY } from '../../constants'
import { useApp } from '../../model'
import style from './index.module.css'

type FieldType = {
    username?: string;
    password?: string;
};

const USERNAME_KEY = '___username'
const PASSWORD_KEY = '___password'

const username = localStorage.getItem(USERNAME_KEY) ?? ''
const password = localStorage.getItem(PASSWORD_KEY) ?? ''

const App: React.FC = () => {
    const [loading, setLoading] = useState(false)
    const [rememberMe, setRememberMe] = useState(true);
    const app = useApp()
    const onFinish = (values: any) => {
        setLoading(true)
        login({ phone: values.username, password: values.password, appId: APP_ID })
            .then(res => {
                if (res.success) {
                    if (rememberMe) {
                        localStorage.setItem(USERNAME_KEY, values.username)
                        localStorage.setItem(PASSWORD_KEY, values.password)
                    } else {
                        localStorage.removeItem(USERNAME_KEY)
                        localStorage.removeItem(PASSWORD_KEY)
                    }
                    const rediretTo = window.location.search.split('?href=')[1]
                    Cookie.set(ACCESS_TOKEN_KEY, res.data.accessToken, { expires: res.data.expireIn })
                    Cookie.set(USER_ID_KEY, res.data.info.userId, { expires: res.data.expireIn })
                    app.setState('currentUserId', res.data.info.userId)
                    app.setState('currentUser', res.data.info)
                    window.location.href = rediretTo || '/'
                } else {
                    notification.error({ message: res.msg })
                }
                setLoading(false)
            }).catch(err => {
                setLoading(false)
                notification.error({ message: err.message || '登录失败,请重试' })
            })
    };

    return (
        <div className={style.bg} style={{
            margin: '0 auto',
            textAlign: 'center',
            display: 'flex', // 使用 Flexbox
            justifyContent: 'center', // 水平居中
            alignItems: 'center', // 垂直居中
            minHeight: '100vh', // 确保占满视口高度
        }}>
            <div className={style.container}>
                <h2>登录</h2>
                <Form
                    style={{
                        maxWidth: 300,
                        margin: '0 auto',
                    }}
                    initialValues={{ username, password }}
                    onFinish={onFinish}
                    layout='vertical'
                >
                    <Form.Item<FieldType>
                        className={style.input}
                        rules={[{ required: true, message: '请输入手机号!' }]}
                        name="username"
                    >
                        <Input size='large' name="username" placeholder='请输入手机号' />
                    </Form.Item>

                    <Form.Item<FieldType>
                        className={style.input}
                        rules={[{ required: true, message: '请输入密码!' }]}
                        name="password"
                    >
                        <Input.Password size='large' placeholder='请输入密码' />
                    </Form.Item>
                    <div style={{ display: 'flex', alignItems: ' center' }}>
                        <Checkbox onChange={e => setRememberMe(e.target.checked)} checked={rememberMe} />
                        <span>&nbsp; 记住我</span>
                        <br />
                        <br />
                    </div>
                    <Form.Item>
                        <Button style={{ width: '100%', height:'40px', marginTop: '20px' }} loading={loading} type="primary" htmlType="submit">
                            登录
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
}

export default App;